import styled, { createGlobalStyle } from "styled-components";

export const fontFamily = '"Optima", sans-serif';

import OPTIMA from './fonts/OPTIMA.woff';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "Optima";
    src: url('${OPTIMA}') format('woff');
  }
`;

export const Title = styled.a`
  font-family: ${fontFamily};
  font-style: normal;
  font-weight: 200;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 4em;
  margin-top: 0px;
  margin-bottom: 0px;
  width: 100%;

  &:visited {
    color: black;
  }
`;

export const Button = styled.a`
  display: inline-block;
  border-radius: 3px;
  background: transparent;
  color: black;

  border: 2px solid black;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
  margin-bottom: 8px;

  font-family: ${fontFamily};
  font-style: normal;
  font-weight: 200;
  font-size: 2em;
  text-align: center;

  width: 100%;
`;

export const SubSection = styled.div`
  display: inline-block;
  border-radius: 3px;
  background: transparent;
  color: black;

  border: 2px solid black;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  padding-top: 32px;
  padding-bottom: 32px;
  margin-top: 8px;
  margin-bottom: 8px;

  text-align: center;

  width: 100%;
`;

export const SectionHeader = styled.div`
  font-family: ${fontFamily};
  font-style: normal;
  font-weight: 200;
  font-size: 2em;
  text-align: center;

  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
`;

export const Section = styled.div`
  margin: auto;

  width: 100%;
  @media only screen and (min-width: 1080px) {
    width: 1060px;
  }
`;

export const LogoImage = styled.img`
  margin: auto;
  max-width: 40%;
  height: auto;
`;

export const GridImage = styled.img`
  margin: auto;
  padding: 2px;
  width: 30%;
  height: auto;
`;

export const GalleryContainer = styled.div`
  font-family: ${fontFamily};
  font-style: normal;
  font-weight: 200;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center; // centers the image horizontally
  align-items: center; //centers the image vertically
`;

export const GalleryImage = styled.img`
  margin: auto;
  padding: 2px;
  width: 30%;
  height: auto;

  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const GalleryBackButton = styled.img`
  width: 50px;
  height: 50px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const GalleryArrow = styled.img`
  width: 50px;
  height: 50px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const LeftGalleryArrow = styled(GalleryArrow)`
  transform: scaleX(-1); // flips image horizontally
`;

export const RightGalleryArrow = styled(GalleryArrow)`
  // no transform needed, image is used as is
`;


export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ImageSection = styled.div`
  margin: auto;
  width: 30%;
`;

export const Image = styled.img`
  margin: auto;
  padding: 2px;
  width: 75%;
  height: auto;
`;

export const TextSection = styled.div`
  margin: auto;
  width: 60%;
`;